// post_status (i.e. key of the map) has to be a maximum of 20 characters long
export const StatusMap = {
    assigned: 'Assigned',
    unassigned: 'Unassigned',
    sent_to_editor: 'Sent to Editor',
    syn_sent_to_editor: 'Syndication Sent to Editor',
    ready_to_repost: 'Ready to Repost',
    ready_to_delete_an: 'Ready to Delete Apple News',
    syndication_retired: 'Syndication Retired',
    revision_requested: 'Revision Requested',
    add_assigned: 'Page Additions Assigned',
    add_sent_to_editor: 'Page Additions Sent to Editor',
    imported: 'Imported',
    publish: 'Published',
    future: 'Scheduled',
    cloned: 'Copy Ready',
    publish_ready: 'Ready to Publish'
}

export class Assignment {
    abbreviation = '';
    ads = [];
    affiliated = false;
    affiliates = '';
    articleTitle = '';
    categories = [];
    childType = 'slideshow';
    clones = '';
    cloneMaster = 0;
    dmc = 0;
    dueDate = '';
    lastReviewDate = '';
    editor = 0;
    editorQueue = false;
    hidePost = '';
    intro = true;
    introWordCount = 100;
    importBlogId = 0;
    importPostId = 0;
    metaDescription = '';
    metaTitle = '';
    metaImage = '';
    msnFields = [
        {
            category: 'Posting Type',
            slug: 'msn-posting-type',
            selectedOption: 'None',
            options: ['None', 'New content', 'Original', 'Copy + Refresh', 'Ext Opt', 'Internal Opt', 'Rewrite', 'Mini Refresh']
        },
        {
            category: 'Publish Status',
            slug: 'msn-publish-status',
            selectedOption: 'Unpublished',
            options: ['Published', 'Unpublished']
        },
        {
            category: 'Format',
            slug: 'msn-format',
            selectedOption: 'None',
            options: ['None', 'SPL', 'Gallery', 'Quiz']
        }
    ];
    ogDescription = '';
    ogImage = '';
    ogTitle = '';
    narrative = false;
    n2s = false;
    outro = false;
    outroWordCount = 100;
    pageAddDate = '';
    pageAddWriter = 0;
    previousStatus = '';
    primarySite = 0;
    priority = 1;
    published = false;
    publishDate = '';
    quizType = '';
    reference = '';
    sites = [];
    siteCategorySearch = '';
    slideCount = 20;
    slides = '';
    slideWordCount = 100;
    slug = '';
    status = 'unassigned';
    targetPublishDate = '';
    taxonomies = {};
    taxonomySearch = '';
    team = [];
    title = '';
    type = 'assignments';
    writer = 0;
    mlPrompt = '';

    constructor(args) {
        for(var i in args) {
            this[i] = args[i];
        }
    }
}